import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const recruitingHiringCriteriaCategoryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export type RecruitingHiringCriteriaCategoryQueryLinkerSchema = z.infer<
  typeof recruitingHiringCriteriaCategoryQueryLinkerSchema
>;

export const recruitingHiringCriteriaCategoryQuerySchema = z.object({
  ...recruitingHiringCriteriaCategoryQueryLinkerSchema.shape,
  status: statusQuerySchema,
});

export type RecruitingHiringCriteriaCategoryQuerySchema = z.infer<typeof recruitingHiringCriteriaCategoryQuerySchema>;

export const recruitingHiringCriteriaCategoryQueryAllSchema = paginatedResponseSchema(
  recruitingHiringCriteriaCategoryQuerySchema
);
export type RecruitingHiringCriteriaCategoryQueryAllSchema = z.infer<
  typeof recruitingHiringCriteriaCategoryQueryAllSchema
>;
